import { PaintedScene } from '../PaintedScene';

export const FAR_PILLAR_PHASER_KEY = 'FarPillarScene' as const;
export const FAR_PILLAR_MANIFEST_KEY = 's-005-far-pillar' as const;

export class FarPillarScene extends PaintedScene {
  constructor() {
    super(FAR_PILLAR_PHASER_KEY, FAR_PILLAR_MANIFEST_KEY);
  }
}
